import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appDisabled]',
  standalone: true
})
export class DisabledDirective implements AfterViewInit {

  constructor(
    private readonly element: ElementRef,
  ) { }

  @Input()
  public disableType?: 'full' | 'visual' | 'no-visual' | 'hidden' = 'full';

  @Input('appDisabled')
  public set value(v: boolean) {
    this._value = v;
    this.define();
  };

  private _value?: boolean | '' = true;

  public ngAfterViewInit(): void {
    this.define();
  }

  public define(): void {
    if (this._value === '')
      this._value = true

    this.element.nativeElement.classList.remove('opacity-50');
    this.element.nativeElement.classList.remove('pointer-events-none');
    this.element.nativeElement.classList.remove('hidden');

    if (!this._value)
      return;

    if (this.disableType === 'full') {
      this.element.nativeElement.classList.add('opacity-50');
      this.element.nativeElement.classList.add('pointer-events-none');
    }

    if (this.disableType === 'visual')
      this.element.nativeElement.classList.add('opacity-50');

    if (this.disableType === 'no-visual')
      this.element.nativeElement.classList.add('pointer-events-none');

    if (this.disableType === 'hidden')
      this.element.nativeElement.classList.add('hidden');
  }

}
